import React from "react";
import logo from "../assets/logos/logo_holistique_mini.webp";
import "./AboutUs.css";

export default function Nosotros() {
  return (
    <div className="about-us-container">
      <div className="about-us-text">
        <h1>¿Quiénes Somos?</h1>

        <p className="about-paragraph-1">
          Somos un hub costarricense especializado en dermatología y medicina estética,
          con proyección internacional y más de una década de experiencia en el mercado centroamericano.
          Representamos marcas líderes y certificadas a nivel mundial, provenientes de países como Italia,
          Francia, España, Estados Unidos, Corea, Argentina e Israel.
        </p>

        {/* 👇 Esta sección solo se verá en modo móvil */}
        <div className="about-bottom-section">
          <p className="about-paragraph-2">
            Nos destacamos por ofrecer tecnologías y suministros médicos de alta gama, garantizando seguridad,
            innovación y resultados reales. Además, brindamos capacitación continua con especialistas,
            fomentando el conocimiento, la excelencia profesional y el crecimiento de nuestros clientes.
          </p>
          <img src={logo} alt="Logo-Holistique" className="about-logo-mobile" />
        </div>
      </div>

      {/* 👇 Este logo solo se verá en pantallas grandes */}
      <img src={logo} alt="Logo-Holistique" className="about-logo-desktop" />
    </div>
  );
}
